import { overlay } from 'modules/overlay';
import { OVERLAY_VIEWS } from 'constants/templates';

/**
 * @type {function}
 * @desc Open error overlay.
 * @example
 * import * as errorOverlay from 'utils/errorOverlay';
 * errorOverlay.open( ...args );
 */
export const open = ( data = {} ) => {
    log.debug( 'errorOverlay.open()' );

    return overlay.open( {
        settings: {
            modalType: OVERLAY_VIEWS.ERROR_VIEW,
            showCloseButton: false,
        },
        config: {},
        data: data,
    } );
};
